import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from 'react-bootstrap'
import authServices from 'services/authServices'
import { appRoutes } from 'constants/routes/appRoutes'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { getReturnUrl } from 'utils/authHelpers'
import { authAndSignApiRoutes } from 'constants/routes/authAndSignApiRoutes'
import { CookieType } from 'constants/enums/cookieTypes'
import ExternalServices from 'services/externalServices'
import { VirtualPagePaths } from 'constants/values/gtmConstants'

const AutoAuthentication = () => {
	const { t } = useTranslation()
	const [isAutologin, setAutoLogin] = useState<boolean>(true)

	async function login(birthDate: string, applicationId: string) {
		try {
			const { secret, returnUrl } = await authServices.authenticate(
				authAndSignApiRoutes.auth.autoAuthenticate,
				'',
				birthDate,
				applicationId,
				t,
			)
			sessionStorage.setItem(
				CookieType.RedirectUrl,
				`/application?applicationid=${applicationId}`,
			)
			ExternalServices.pushVirtualPageView(VirtualPagePaths.DE.LOGIN_COMPLETE)
			authServices.redirectTo(returnUrl || getReturnUrl(), secret)
		} catch (e) {
			console.log(e)
			ExternalServices.pushVirtualPageView(VirtualPagePaths.DE.AUTO_LOGIN_ERROR)
			setAutoLogin(false)
		}
	}

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search)
		const birthDate = searchParams.get('birthdate')
		const applicationId = searchParams.get('applicationid')

		if (applicationId && birthDate && birthDate.length >= 10) {
			ExternalServices.pushVirtualPageView(VirtualPagePaths.DE.AUTO_LOGIN)
			login(birthDate.substring(0, 10), applicationId)
		} else {
			ExternalServices.pushVirtualPageView(VirtualPagePaths.DE.AUTO_LOGIN_ERROR)
			setAutoLogin(false)
		}
		// eslint-disable-next-line
	}, [])

	return (
		<Container className="spinner-container d-flex justify-content-center align-items-center">
			{isAutologin ? (
				<div className="col-spinner">
					<CircleSpinner />
				</div>
			) : (
				(window.location.href = appRoutes.login)
			)}
		</Container>
	)
}

export default AutoAuthentication
